module.exports = __webpack_public_path__ + "img/c300x300.78fea646.jpg";